import { BreakpointState } from "@angular/cdk/layout";
import { Observable, map } from "rxjs";

import { IconButtonSize, MEDIUM, SMALL } from "@hermes/aphrodite/icon-button";

export interface IconConfiguration {
    isDesktop: boolean;
    buttonSize: IconButtonSize;
    iconSize: number;
}

export function computeIconConfiguration$(
    breakpointState$: Observable<BreakpointState>,
): Observable<IconConfiguration> {
    return breakpointState$.pipe(
        map((breakpoint) => breakpoint.matches),
        map((isDesktop) => ({
            isDesktop,
            buttonSize: isDesktop ? MEDIUM : SMALL,
            iconSize: isDesktop ? 11 : 9,
        })),
    );
}
